// extracted by mini-css-extract-plugin
module.exports = {"RegionsCard":"slXxm","RegionsCard__Title":"Yh3W0","RegionsCard__Subtitle":"znTf8","RegionsCard__Control":"z4lQe","RegionsCard__Button":"rxsS9","RegionsCard__Icon":"Lw9BN"};